import { AI_MATE_CONTEXT } from '@atlaskit/analytics-namespaced-context';

import {
	type AIMateAnalyticsSource,
	ALLOWED_AI_MATE_SOURCES,
	type SourceAndAttributes,
} from './types';

const isSourceAndAttributes = (x: unknown): x is SourceAndAttributes => {
	if (typeof x !== 'object' || x === null) {
		return false;
	}

	if (
		!('source' in x) ||
		!('attributes' in x) ||
		typeof x.attributes !== 'object' ||
		x.attributes === null
	) {
		return false;
	}

	return ALLOWED_AI_MATE_SOURCES.includes(x.source as AIMateAnalyticsSource);
};

/**
 * Extracts the attributes from the relevant AIMate contexts.
 * Contexts is an array of (any) object - to determine which objects we want to extract the attributes from,
 * we add a source of 'AIMate' to the object, or check if it has the AI Mate namespace
 */
export const getAttributesFromContexts = (context: unknown): Record<string, any> => {
	if (!context || !Array.isArray(context)) {
		return {};
	}

	let contextsThatHaveAttributes = context.filter(
		(x) => isSourceAndAttributes(x) || x[AI_MATE_CONTEXT],
	);

	return contextsThatHaveAttributes.reduce((acc, x) => {
		return {
			...acc,
			...(x[AI_MATE_CONTEXT]?.attributes ?? {}),
			...(x.attributes ?? {}),
		};
	}, {});
};
